export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
        <div className="absolute top-1/3 left-1/2 w-[300px] h-[300px] rounded-full bg-secondary-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>全网热播剧集免费追</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
              菲菲影院
              <span className="block text-primary-500 mt-1">高清不缓冲 · 免费在线观看</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 mt-2 mb-5 leading-relaxed">
              海量电影电视剧全集，热播剧免费追剧在线看不卡顿
            </p>

            <div className="text-sm text-foreground-500 leading-relaxed mb-6 space-y-2">
              <p>菲菲影院汇聚全球热门影视资源，涵盖悬疑、古装、甜宠、动作、动漫等全品类内容。平台采用智能CDN加速与高清编码技术，确保每一帧画面清晰流畅，告别缓冲等待。内容团队每日实时更新最新剧集和片源，院线大片下映即刻上线，热播剧同步追更，让你始终走在追剧第一线。</p>
              <p>当前暑期档特辑火热进行中，悬疑剧场、古装大剧、韩剧精选等多个主题专区同步开放，百部高分佳作等你来探索发现。</p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7 text-xs md:text-sm text-foreground-500">
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-primary-500 text-base"></i>
                <span>覆盖<strong className="text-foreground-800">10万+</strong>影视资源</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-primary-500 text-base"></i>
                <span>每日<strong className="text-foreground-800">实时更新</strong>热门剧集</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-primary-500 text-base"></i>
                <span>全站<strong className="text-foreground-800">免费高清</strong>无广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="inline-flex items-center gap-2 px-8 py-3 border-2 border-primary-300 text-primary-600 font-semibold text-sm rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                探索专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20experience%20warm%20golden%20lighting%20luxurious%20velvet%20seats%20grand%20screen%20with%20glowing%20film%20projection%20elegant%20atmosphere%20soft%20shadows%20rich%20amber%20and%20coral%20tones%20high%20quality%20photography%20artistic%20composition&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                  alt="菲菲影院高清观影体验 - 沉浸式影视享受"
                  title="菲菲影院高清观影体验"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-background-50 rounded-xl px-4 py-3 shadow-sm border border-background-200 hidden md:block">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-play-circle-fill text-primary-500"></i>
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-foreground-800 whitespace-nowrap">正在热播</div>
                    <div className="text-xs text-foreground-500">3.2万人在线观看</div>
                  </div>
                </div>
              </div>
              <div className="absolute -top-4 -left-4 bg-background-50 rounded-xl px-4 py-3 shadow-sm border border-background-200 hidden md:block">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500"></i>
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-foreground-800 whitespace-nowrap">4K超清专区</div>
                    <div className="text-xs text-foreground-500">百部大片已上线</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}